<template>
  <van-dialog v-model="show" message="该用户已脱单，资料已下架" confirmButtonText="知道了" :close-on-click-overlay="true" @close="close"></van-dialog>
</template>

<script>
export default {
  nname: 'banModal',
  props: ['showModal'],
  model: {
    prop: 'showModal',
    event: 'close'
  },
  computed: {
    show: {
      get () {
        return this.showModal
      },
      set (val) {
        this.$emit('close', val)
      }
    }
  },
  methods: {
    close () {
      this.show = false
    }
  }
}
</script>

<style lang="scss">

</style>